// extracted by mini-css-extract-plugin
export default {"base":"PrincipalDivisionPais_base__QCUBV","titulo":"PrincipalDivisionPais_titulo__1vV3E","contenedorCuadros":"PrincipalDivisionPais_contenedorCuadros__s6lUm"};